import { render } from "./TierSelector.vue?vue&type=template&id=5de00aaf&scoped=true&ts=true"
import script from "./TierSelector.vue?vue&type=script&lang=ts"
export * from "./TierSelector.vue?vue&type=script&lang=ts"

import "./TierSelector.vue?vue&type=style&index=0&id=5de00aaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de00aaf"]])

export default __exports__